import Typography from 'components/Typography';
import PageHeader from 'components/PageHeader';
import Button from 'components/Button';
import FormActionGroup from 'components/FormActionGroup';
import FormGroup from 'components/FormGroup';
import TextField from 'components/TextField';
import ListWrapper from 'components/ListWrapper';
import CardContent from 'components/CardContent';
import {validateEmail} from 'utils/validators';
import useAccountForm from './useAccountForm';
import styles from './AccountForm.module.scss';
import {useState} from 'react';
import EyeIcon from '../EmployeeForm/icons/eye.svg';
import EyeDisabledIcon from '../EmployeeForm/icons/eye-disable.svg';
import {phoneFormat} from 'helpers/phoneFormat';

function AccountForm() {
  const {submitting, errors, register, handleSubmit} = useAccountForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  return (
    <form onSubmit={handleSubmit}>
      <PageHeader>
        <Typography variant="h2">Account</Typography>
      </PageHeader>
      <ListWrapper>
        <CardContent px="md" pt="none" pb="md">
          <FormGroup columns={2}>
            <TextField
              label="First Name"
              placeholder="First Name"
              {...register('first_name', {required: 'Required'})}
              error={errors.first_name?.message}
            />
            <TextField
              label="Last Name"
              placeholder="Last Name"
              {...register('last_name', {required: 'Required'})}
              error={errors.last_name?.message}
            />
          </FormGroup>

          <FormGroup columns={2}>
            <TextField
              label="Email Address"
              placeholder="Email Address"
              {...register('email', {
                required: 'Required',
                validate: validateEmail,
              })}
              error={errors.email?.message}
            />
            <TextField
              label="Phone Number"
              placeholder="(123) 456-7890"
              {...register('phone', {
                required: 'Required',
                minLength: {
                  value: 14,
                  message: 'Enter a valid phone number',
                },
              })}
              onChange={(e) => {
                e.target.value = phoneFormat(e.target.value);
              }}
              error={errors.phone?.message}
            />
          </FormGroup>

          <FormGroup columns={3}>
            <TextField
              label="Username"
              placeholder="Username"
              {...register('username', {
                required: 'Required',
              })}
              error={errors.username?.message}
            />
            <div style={{position: 'relative'}}>
              <TextField
                label="Password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                {...register('password')}
                error={errors.password?.message}
              />
              <img
                onClick={() => setShowPassword((pr) => !pr)}
                className={styles.eyeIcon}
                src={showPassword ? EyeIcon : EyeDisabledIcon}
                alt="eye"
              />
            </div>
            <div style={{position: 'relative'}}>
              <TextField
                label="Password Confirmation"
                type={showPassword1 ? 'text' : 'password'}
                placeholder="Password Confirmation"
                {...register('password_confirmation')}
                error={errors.password_confirmation?.message}
              />
              <img
                onClick={() => setShowPassword1((pr) => !pr)}
                className={styles.eyeIcon}
                src={showPassword1 ? EyeIcon : EyeDisabledIcon}
                alt="eye"
              />
            </div>
          </FormGroup>
          <FormActionGroup className={styles.action_group}>
            <Button type="submit" color="green" loading={submitting}>
              Save
            </Button>
          </FormActionGroup>
        </CardContent>
      </ListWrapper>
    </form>
  );
}

export default AccountForm;
